import styled from 'styled-components';
import { colors } from '../../constants/colors';

export const TooltipStyled = {
  tooltip: {
    sx: {
      bgcolor: colors.tooltipBG,
      color: colors.tooltipText
    }
  }
};

export const ContainerStyled = styled.div`
  width: 100% !important;
  max-width: 100% !important;
  padding: 0 10px;
`;
